import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import {apolloClient} from './libs/apollo'
import './registerServiceWorker'
import axios from 'axios'
import {inject as injectFontAwesome} from './libs/fontAwesome.js'
import injectDirectives from "./libs/directives";
import {i18n} from "./libs/i18n";
import { VueReCaptcha } from 'vue-recaptcha-v3';
import VueMeta from 'vue-meta'
import money from 'v-money'
import VueTheMask from 'vue-the-mask'

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

injectFontAwesome(Vue);
injectDirectives(Vue);
Vue.config.productionTip = false;
Vue.prototype.$apolloClient = apolloClient;

Vue.use(VueTheMask)
Vue.use(money)
Vue.use(VueMeta)
Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    loaderOptions: {
        // useRecaptchaNet: true,
        autoHideBadge: true
    }
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    async created () {
        await store.dispatch('thermalPrinter/init')
        this.$mount('#app')
    }
})
